import { EMortgageBuildingType } from '../../types/mortgage/mortgageType';

export const parseRealtyType = (buildingType?: EMortgageBuildingType) => {
  switch (buildingType) {
    case EMortgageBuildingType.HousePart:
      return 'room';
    case EMortgageBuildingType.NewBuilding:
      return 'flatNew';
    case EMortgageBuildingType.OldBuilding:
      return 'flatSecondary';
    case EMortgageBuildingType.Suburban:
      return 'houseOrTownhouse';
    default:
      return undefined;
  }
};
